<template>
  <validation-observer ref="formValidate">
    <b-modal
      id="modal-periodo"
      title="Información del periodo"
      size="xl"
      ok-only
      ok-title="Guardar periodo"
      :visible="showModal"
      @hide="defaultInfo"
      @change="(val) => $emit('update:show-modal', val)"
    >
      <b-overlay
        :show="loader.all"
        rounded="sm"
      >
        <b-form
          class="py-75"
          @submit.prevent="validationForm"
        >
          <!-- Clave y temporalidad -->
          <b-row>
            <!-- Clave -->
            <b-col
              xl="4"
              sm="12"
              class="mb-2"
            >
              <b-form-group
                label="Clave de periodo"
              >
                <validation-provider
                  #default="{ errors }"
                  name="clave"
                  rules="required|min:5|max:10|rule-perdiodo"
                >
                  <b-form-input
                    id="id-clave"
                    v-model="form.clave"
                    class="form-control"
                    :class="{ 'is-invalid' : (errors.length > 0 ? false : null) == false }"
                    placeholder="clave del periodo (ej. 2024-A)"
                  />
                  <small>Utilice nomenclatura para identificar el periodo y el plan</small>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Capacidad -->
            <b-col
              xl="4"
              sm="12"
              class="mb-2"
            >
              <b-form-group
                label="Capacidad de estudiantes"
              >
                <validation-provider
                  #default="{ errors }"
                  name="capacidad"
                  rules="between:0,1000"
                >
                  <b-form-input
                    id="id-cupo"
                    v-model="form.capacidad"
                    type="number"
                    placeholder="Dejar en blanco para ilimitado"
                    class="form-control"
                    :class="{ 'is-invalid' : (errors.length > 0 ? false : null) == false }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Temporalidad -->
            <b-col
              xl="4"
              sm="12"
              class="mb-2"
            >
              <b-form-group
                label="Temporalidad"
              >
                <b-skeleton-wrapper :loading="loader.temporalidades">
                  <!-- Loader -->
                  <template #loading>
                    <b-skeleton
                      width="100%"
                      type="button"
                    />
                  </template>

                  <validation-provider
                    #default="{ errors }"
                    name="temporalidad"
                    rules="required"
                  >
                    <b-form-input
                      v-show="false"
                      v-model="form.temp"
                      readonly
                    />
                    <b-dropdown
                      id="id-temporalidad"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      block
                      :text="nameTemp"
                      :variant="form.temp ? 'primary' : (errors.length > 0) ? 'danger' : 'secondary'"
                    >
                      <b-dropdown-item
                        v-for="temp in temporalidades"
                        :key="temp.id"
                        :variant="form.temp == temp.id ? 'primary' : ''"
                        @click="form.temp = temp.id"
                      >
                        {{ temp.nombre }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-skeleton-wrapper>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              xl="4"
              sm="12"
              class="mb-2"
            > <selectModalidades
              :modalidad.sync="form.modalidad"
              @tipomodalidad="form.modalidad=$event"
            />
            </b-col>
            <!-- Checkbox-->
            <b-col
              xl="4"
              sm="12"
              class="mb-2"
            >
              <b-form-checkbox
                v-model="form.privado"
                class="mb-1"
                :unchecked-value="0"
                :value="1"
                switch
              > Este Periodo es
                <span v-if="form.privado === 1">Privado <p>[No se publicará en la oferta academica.]</p></span>
                <span v-else>Público</span>
              </b-form-checkbox>
            </b-col>
            <b-col
              xl="4"
              sm="12"
              class="mb-2"
            >
              <b-form-checkbox
                v-model="form.requiere_docs"
                class="mb-1"
                :unchecked-value="0"
                :value="1"
                switch
              > Este Periodo
                <span v-if="form.requiere_docs === 1">Requerirá Documentación</span>
                <span v-else><b>No</b> Requerirá Documentación</span>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <!-- Fecha de inicio y fin -->
          <b-row>
            <!-- Fecha de inicio -->
            <b-col
              xl="6"
              sm="12"
              class="mb-2"
            >
              <b-form-group
                label="Fecha de inicio"
              >
                <b-calendar
                  id="fechaI"
                  block
                  hide-header
                  value-as-date
                  start-weekday="1"
                  today-variant="secondary"
                  v-bind="calendarSpanish"
                  :date-info-fn="dateDuration"
                  :value="timestampToDate(form.dateI, 'unformated')"
                  @input="form.dateI = $event.getTime() / 1000"
                />
              </b-form-group>
            </b-col>
            <!-- Fecha de fin -->
            <b-col
              xl="6"
              sm="12"
              class="mb-2"
            >
              <b-form-group
                label="Fecha de fin"
              >
                <b-calendar
                  id="fechaF"
                  block
                  hide-header
                  value-as-date
                  start-weekday="1"
                  selected-variant="danger"
                  today-variant="secondary"
                  v-bind="calendarSpanish"
                  :date-info-fn="dateDuration"
                  :date-disabled-fn="dateDisabled"
                  :value="timestampToDate(form.dateF, 'unformated')"
                  @input="form.dateF = $event.getTime() / 1000"
                />
              </b-form-group>
            </b-col>
            <!-- Mensaje por si la fecha de inicio es después que la de fin -->
            <b-col
              cols="12"
              class="mb-1 text-center"
            >
              <b-alert
                v-height-fade.appear
                :show="form.dateF < form.dateI"
                variant="danger"
              >
                <div class="alert-body">
                  <span>La fecha de inicio <b>NO</b> puede ser posterior a la fecha de fin.</span>
                </div>
              </b-alert>
            </b-col>
          </b-row>
          <b-alert
            :show="imUpdating"
            variant="warning"
          >
            <h4 class="alert-heading">
              Está editando el periodo: {{ toEdit.clave }} ({{ nameTemp }})
            </h4>
          </b-alert>
        </b-form>
      </b-overlay>

      <template #modal-footer>
        <b-button
          variant="primary"
          :disabled="loader.all"
          @click.prevent="validationForm"
        >
          Guardar información
        </b-button>
        <b-button
          v-if="imUpdating"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="danger"
          class="ml-25 btn-icon"
          :disabled="loader.all"
          @click="deleteItem"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  ref, computed, onMounted, getCurrentInstance, watch,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { heightFade } from '@core/directives/animations'
import { calendarSpanish, isObject, isEmptyObject } from '@core/utils/utils'
import { required } from '@validations'
import { timestampToDate } from '@core/utils/filter'
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BSkeletonWrapper,
  BSkeleton,
  BCalendar,
  BAlert,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import selectModalidades from '@/views/components/selects/select-modalidades.vue'
import { temporalitiesList } from '../edicion-plan/usePlanes'
import { saveData } from './usePeriodos'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BSkeletonWrapper,
    BSkeleton,
    BCalendar,
    BAlert,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BOverlay,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    selectModalidades,
  },
  directives: {
    Ripple,
    heightFade,
  },
  model: {
    prop: 'showModal',
    event: 'update:show-modal',
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    toEdit: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    // eslint-disable-next-line no-unused-vars

    const temporalidades = ref([])
    const form = ref({
      clave: null, temp: null, dateI: null, dateF: null, capacidad: null, privado: 0, requiere_docs: 1, modalidad: null,
    })
    const loader = ref({ temporalidades: false, all: false })
    const formValidate = ref(null)
    const vm = getCurrentInstance().proxy

    // * Colorea los días de duración del periodo en el calendario
    const dateDuration = (ymd, date) => (date >= timestampToDate(form.value.dateI, 'unformated') && date <= timestampToDate(form.value.dateF, 'unformated') ? 'table-primary' : '')

    // * Deshabilita las fechas anteriores a la fecha de inicio en el calendario de fin
    const dateDisabled = (ymd, date) => date < timestampToDate(form.value.dateI, 'unformated')

    // * Retornar nombre de temporalidad seleccionada
    const nameTemp = computed(() => {
      if (form.value.temp) return temporalidades.value.find(item => item.id === form.value.temp).nombre
      return 'Seleccione temporalidad'
    })

    // * Retornar si se está editando o no
    const imUpdating = computed(() => isObject(props.toEdit) && !isEmptyObject(props.toEdit))

    // * Cargar catálogo de temporalidades
    const loadTemporalities = () => {
      loader.value.temporalidades = true
      temporalitiesList().then(response => {
        loader.value.temporalidades = false
        temporalidades.value = response
      }, error => {
        loader.value.temporalidades = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Carga de temporalidades]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    // * Asigna datos de objeto predeterminados
    const defaultInfo = () => {
      form.value = {
        clave: null, temp: null, capacidad: null, privado: 0, requiere_docs: 1, modalidad: 1, dateI: Math.floor(Date.now() / 1000), dateF: Math.floor(Date.now() / 1000),
      }
    }

    // * Revisa cuando se abra el modal y precarga datos si es edición
    watch(() => props.showModal, value => {
      if (value && isObject(props.toEdit) && !isEmptyObject(props.toEdit)) {
        form.value = {
          clave: props.toEdit.clave,
          temp: props.toEdit.temporalidad,
          modalidad: props.toEdit.modalidad,
          dateI: props.toEdit.fecha_ini,
          dateF: props.toEdit.fecha_fin,
          capacidad: props.toEdit.capacidad != null ? props.toEdit.capacidad : null,
          privado: props.toEdit.privado,
          requiere_docs: props.toEdit.requiere_docs,
        }
      }
    })

    // * Hace llamado POST para crear/editar
    const postData = () => {
      const {
        clave, temp, modalidad, dateI, dateF, capacidad, privado, requiere_docs,
      } = form.value

      const data = {
        action: 2,
        clave,
        temp,
        modalidad,
        dateI,
        dateF,
        capacidad,
        privado,
        requiere_docs,
      }

      if (isObject(props.toEdit) && !isEmptyObject(props.toEdit)) {
        data.action = 3
        data.id = props.toEdit.id
      }

      loader.value.all = true
      saveData(data).then(response => {
        loader.value.all = false
        const statusIcon = { 200: 'success', 500: 'error' }

        vm.$swal({
          title: response.message,
          text: (response.status !== 200) ? 'Por favor, verfique que la información ingresada es correcta' : '',
          icon: statusIcon[response.status] || 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
          confirmButtonText: 'Aceptar',
        })

        if (response.status === 200) emit('update-list')
      }, error => {
        loader.value.all = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Guardar datos]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    // * Hace llamado POST para borrar
    const deleteItem = () => {
      vm.$swal({
        title: '¿Está seguro de querer eliminar este periodo?',
        text: 'Esta acción es irreversible, para poder hacer el borrado del periodo, primero se confirmará que no esté siendo utilizado en Campus',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, quiero borrarlo',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          loader.value.all = true
          saveData({ action: 4, id: props.toEdit.id }).then(response => {
            loader.value.all = false
            const statusIcon = { 200: 'success', 500: 'error' }

            vm.$swal({
              title: response.message,
              text: (response.status !== 200) ? 'Por favor, verfique que la información ingresada es correcta' : '',
              icon: statusIcon[response.status] || 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
              confirmButtonText: 'Aceptar',
            })

            if (response.status === 200) emit('update-list')
          }, error => {
            loader.value.all = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error en petición [Eliminar datos]',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          })
        }
      })
    }

    // * Validación de formulario
    const validationForm = () => {
      formValidate.value.validate().then(success => {
        if (success && form.value.dateI <= form.value.dateF) postData()
      })
    }
    extend('rule-perdiodo', {
      message:
    'El {_field_} solo acepta letras mayúsculas sin acento y números; no están permitidos los espacios.',
      validate: value => {
        const cuponvalido = new RegExp(/^[A-Z0-9-]+$/g)
        value.toUpperCase()
        return cuponvalido.test(value)
      },
    })

    onMounted(() => {
      loadTemporalities()
      defaultInfo()
    })

    return {
      // Data
      temporalidades,
      nameTemp,
      form,

      // Options
      dateDuration,
      dateDisabled,
      calendarSpanish,

      // Refs
      formValidate,

      // Function
      defaultInfo,
      deleteItem,
      validationForm,

      // Filters
      timestampToDate,
      required,
      isObject,
      isEmptyObject,
      imUpdating,

      // Loader
      loader,
    }
  },
}
</script>
